import { render, staticRenderFns } from "./FormMultiLineText.vue?vue&type=template&id=2462bc76"
import script from "./FormMultiLineText.vue?vue&type=script&lang=js"
export * from "./FormMultiLineText.vue?vue&type=script&lang=js"
import style0 from "./FormMultiLineText.vue?vue&type=style&index=0&id=2462bc76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports